const TeamCards = () => {

    document.addEventListener("DOMContentLoaded", function() {
        var practiceAreaSelect = document.querySelector('select[name="practice-area"]');
        if (!practiceAreaSelect) return;
        
        practiceAreaSelect.addEventListener("change", function() {
            var selectedCategory = this.value;
            var cards = document.querySelectorAll('.team-card');
            
            // If "all" is selected, remove the hidden class from every card.
            if (selectedCategory === "all") {
                cards.forEach(function(card) {
                    card.classList.remove("hidden");
                });
                return;
            }
            
            cards.forEach(function(card) {
                // Get the value from the custom attribute.
                var practiceAreas = card.getAttribute("practice-areas");
                
                if (practiceAreas) {
                    // Assume practice areas are comma-separated. Adjust if necessary.
                    var areas = practiceAreas.split(",").map(function(area) {
                        return area.trim();
                    });
                    
                    // If the selected category is included, remove the hidden class; otherwise, add it.
                    if (areas.includes(selectedCategory)) {
                        card.classList.remove("hide");
                    } else {
                        card.classList.add("hide");
                    }
                } else {
                    // If the attribute is missing, hide the card.
                    card.classList.add("hide");
                }
            });
        });
    });
}

export default TeamCards;